import { enableProdMode } from '@angular/core';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

// Chart.js imports and configuration
import {
  Chart,
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';
import { applyChartDefaultsFromCss } from './app/core/services/test';

// Register Chart.js components
Chart.register(
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  zoomPlugin,
);
//configure Amplify with the environment variables
Amplify.configure(
  {
    Auth: {
      Cognito: {
        userPoolId: environment.cognitoUserPoolId,
        userPoolClientId: environment.cognitoUserPoolWebClientId,
        identityPoolId: environment.cognitoIdentityPoolId,
        loginWith: {
          oauth: {
            domain: environment.cognitoDomain,
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [environment.cognitoRedirectIn],
            redirectSignOut: [environment.cognitioRedirectOut],
            responseType: 'code',
          },
        },
      },
    },
    API: {
      REST: {
        BOOSTApi: {
          endpoint: environment.gatewayUrl,
        },
        LambdaApi: {
          endpoint: environment.lambdaUrl,
        },
      },
    },
  },
  {
    API: {
      REST: {
        headers: async () => ({
          Authorization: `Bearer ${(
            await fetchAuthSession()
          ).tokens?.idToken?.toString()}`,
        }),
      },
    },
  },
);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .catch((err) => console.error(err));

applyChartDefaultsFromCss(); // initial defaults before boot
// bootstrapApplication(AppComponent).catch(console.error);
